import { cancelAppointmentsApi as generatedCancelAppointmentsApi } from '../generated/appointments/cancelAppointments';

const cancelAppointmentsApi = generatedCancelAppointmentsApi.enhanceEndpoints({
  endpoints: {
    cancelAppointments: {
      invalidatesTags: [
        { id: 'PENDING', type: 'UpcomingAppointment' as const },
        { id: 'UPCOMING', type: 'UpcomingAll' as const },
        { id: 'UPCOMING', type: 'UpcomingAppointment' as const },
        { type: 'Schedule' as const },
        { type: 'Slots' as const },
      ],
    },
  },
});

export const { useCancelAppointmentsMutation } = cancelAppointmentsApi;
export { cancelAppointmentsApi };
